import http from "../utilities/AxiosRequest";
import {addTokenToData, addTokenToURL} from "../utilities/ServerRequestModifier";

class ConstantsService {

    getConstants() {
        return http.get(addTokenToURL("/admin/constants"));
    }

    editConstants(data){
        return http.put(addTokenToURL("/admin/constants"), addTokenToData(data));
    }

}

export default new ConstantsService();
